// Element size without padding and borders
function elementInnerWidth (elem) {
  var computedStyle = getComputedStyle(elem)
  var width = elem.clientWidth

  return width - (parseInt(computedStyle.paddingLeft) + parseInt(computedStyle.paddingRight))
}
function elementInnerHeight (elem) {
  var computedStyle = getComputedStyle(elem)
  var height = elem.clientHeight

  return height - (parseInt(computedStyle.paddingTop) + parseInt(computedStyle.paddingBottom))
}

// Element size with padding and borders and scrollbars
function elementOuterWidth (elem) {
  var width = elem.offsetWidth

  return width
}
function elementOuterHeight (elem) {
  var height = elem.offsetHeight

  return height
}

function elementOuterWidthIncludingMargins (elem) {
  var computedStyle = getComputedStyle(elem)
  var outerWidth = elementOuterWidth(elem)

  return outerWidth + (parseInt(computedStyle.marginLeft) + parseInt(computedStyle.marginRight))
}
function elementOuterHeightIncludingMargins (elem) {
  var computedStyle = getComputedStyle(elem)
  var outerHeight = elementOuterHeight(elem)

  return outerHeight + (parseInt(computedStyle.marginTop) + parseInt(computedStyle.marginBottom))
}

function getComputedStyle (elem) {
  return window.getComputedStyle(elem)
}

export default {
  getComputedStyle,
  elementInnerWidth,
  elementInnerHeight,
  elementOuterWidth,
  elementOuterHeight,
  elementOuterWidthIncludingMargins,
  elementOuterHeightIncludingMargins
}



// WEBPACK FOOTER //
// ./src/library/core/dom.js